import React, { useState, useEffect } from 'react';

import getFetchConfig from '../../../utils/getFetchConfig';
import handleFetchErrors from '../../../utils/handleFetchErrors';
import standardFetchHandlers from '../../../utils/standardFetchHandlers';

import CommonModalWrapper from '../../common-modal-Wrapper/CommonModalWrapper';
import CloseIcon from '../../Icons/CloseIcon';

import RoomRents from '../rentals/Rentals';
import Jobs from '../jobs/Jobs';
import LocalBizServices from '../localbiz-services/LocalBizAndServices';
import BabySitterAndNanny from '../babysitter-and-nanny/BabySitterAndNanny';
import Events from '../events/Events';
import BuyAndSell from '../buy-and-sell/BuyAndSell';
import PostAdsHeading from '../post-ads-heading/PostAdsHeading';
import FormButton from '../../buttons/form-button/FormButton';
import appURLs from '../../../appURL';
import Inputs from '../../Inputs/Inputs';

import style from "./adsCategpries.module.css";
import { toast } from 'react-toastify';

import LoaderScreen from '../loader-screen/LoaderScreen';
import { Modal, Button } from 'react-bootstrap';



export default function AdsCategories({ toggleModalForPostAdscategories = () => { }, checkJobEdit, checkBabyEdit, checkEventEdit, adsIds, checkRentalEdit, setadsIds, checkLocalBizEdit, checkBuySellEdit }) {

    const fetchConfig = getFetchConfig(),
        appURL = appURLs();

    // Exit Confirmation Modal State
    const [showExitConfirmModal, setShowExitConfirmModal] = useState(false);
    const [showSaveDraftModal, setShowSaveDraftModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [currentModalType, setCurrentModalType] = useState('');
    const [currentRoomRentsId, setCurrentRoomRentsId] = useState(null);
    const [currentJobId, setCurrentJobId] = useState(null);
    const [currentEventId, setCurrentEventId] = useState(null);
    const [currentLocalBizId, setCurrentLocalBizId] = useState(null);
    const [currentBuySellId, setCurrentBuySellId] = useState(null);
    const [currentBabySitterId, setCurrentBabySitterId] = useState(null);

    

    // Track current step for each ad type
    const [currentRoomRentsStep, setCurrentRoomRentsStep] = useState(0);
    const [currentJobStep, setCurrentJobStep] = useState(0);
    const [currentEventStep, setCurrentEventStep] = useState(0);
    const [currentLocalBizStep, setCurrentLocalBizStep] = useState(0);
    const [currentBuySellStep, setCurrentBuySellStep] = useState(0);
    const [currentBabySitterStep, setCurrentBabySitterStep] = useState(0);
 
    // Modal handlers
    // const handleShowExitConfirm = (modalType = '') => {
    //     setCurrentModalType(modalType);
    //     setShowExitConfirmModal(true);
    // };

    //     const handleShowExitConfirm = (modalType = '') => {
    //     // If adsIds exists, it means we're editing an existing ad
    //     // So just close the modal without showing save draft option
    //     if (adsIds) {
    //         toggleModalVisibilty(modalType, false);
    //         return;
    //     }

    //     // Otherwise, show the save draft confirmation modal
    //     setCurrentModalType(modalType);
    //     setShowExitConfirmModal(true);
    // };

    // const handleShowExitConfirm = (modalType = '') => {
    //     // Check if there's a draft ID (either from editing or newly created)
    //     if (currentRoomRentsId) {
    //         setCurrentModalType(modalType);
    //         setShowExitConfirmModal(true);
    //     } else {
    //         // No draft exists, just close the modal
    //         toggleModalVisibilty(modalType, false);
    //         toggleModalForPostAdscategories && toggleModalForPostAdscategories(false);
    //     }
    // };
    const handleShowExitConfirm = (modalType = '', currentStep = 0) => {
        // If we're on the congratulations screen (step 4), just close without showing draft modal
        if (currentStep === 4 || currentStep === 5 || currentStep === 3) {
            toggleModalVisibilty(modalType, false);
            toggleModalForPostAdscategories && toggleModalForPostAdscategories(false);
            return;
        }
        
        const hasDraft =
            currentRoomRentsId || currentJobId || currentEventId || currentLocalBizId
            || currentBuySellId || currentBabySitterId;
        // currentLocalBizId;

        if (hasDraft) {
            setCurrentModalType(modalType);
            setShowExitConfirmModal(true);
        } else {
            toggleModalVisibilty(modalType, false);
            toggleModalForPostAdscategories && toggleModalForPostAdscategories(false);
        }
    };


    const handleHideExitConfirm = () => setShowExitConfirmModal(false);

    const handleShowSaveDraft = () => {
        setShowExitConfirmModal(false);
        setShowSaveDraftModal(true);
    };

    const handleHideSaveDraft = () => setShowSaveDraftModal(false);
    const handleShowDelete = () => {
        setShowExitConfirmModal(false);
        setShowDeleteModal(true);
    };

    const handleHideDelete = () => setShowDeleteModal(false);

    const handleCancel = () => setShowExitConfirmModal(false);
    // Save Draft and Delete handlers
    const handleSaveDraft = () => {
        handleHideSaveDraft();
        window.location.reload();
        toggleModalVisibilty(currentModalType, false);
    };

    const handleDeleteAd = async () => {
        handleHideDelete();
        toast.success('Deleted Successfully');
        window.location.reload();
        toggleModalVisibilty(currentModalType, false);
    };

    const contactModeRadioBtn = [
        {
            label: "Offering - I have a job to offer",
            value: "1"
        },
        {
            label: "Wanted - I am looking for a job",
            value: "2"
        },

    ];

    const [selectedJobType, updateSelectedJobType] = useState(``);

    const [replaceJobs, setReplaceJobs] = useState(false);
    const [Replacerental, setReplacerental,] = useState(false);
    const [replaceBaby, setReplaceBaby] = useState(false)
    const [replaceEvents, setReplaceEvents] = useState(false);
    const [replaceLocalBiz, setReplaceLocalBiz] = useState(false);
    const [replaceBuySell, setReplaceBuySell] = useState(false);

    const [isModalOpenForRoomRents, updateVisibilityForRoomRents] = useState(false),
        [isModalOpenForJobs, updateVisibilityForJobs] = useState(false),
        [isModalOpenForBuyAndSell, updateVisibilityForBuyAndSell] = useState(false),
        [isModalOpenForEvents, updateVisibilityForEvents] = useState(false),
        [isModalOpenForLocalBizAndService, updateVisibilityForLocalBizAndService] = useState(false),
        [isModalOpenForBabySitterAndNanny, updateVisibilityForBabySitterAndNanny] = useState(false);

    const [adsCategories, updateAdsCategories] = useState([]),
        [selectedAdsCategories, updatedSelectedAdsCategories] = useState({
            adsCategoriesId: "",
            optionText: ""
        });
    // fetching ads categories
    // const fetchingPostACategories = () => {

    //     fetch(`${appURL}/posts/types`, {
    //         ...fetchConfig,
    //         method: "GET"
    //     })
    //         .then(handleFetchErrors)
    //         .then((res) => {
    //             const adsTypesArr = res?.postType;
    //             debugger
    //             if (adsTypesArr?.length) updateAdsCategories(adsTypesArr); 
    //         })
    //         .catch((err) => standardFetchHandlers.error(err));
    // }

    const fetchingPostACategories = () => {
        fetch(`${appURL}/posts/types`, {
            ...fetchConfig,
            method: "GET"
        })
            .then(handleFetchErrors)
            .then((res) => {
                const adsTypesArr = res?.postType;
                if (adsTypesArr?.length) {
                    const transformedCategories = adsTypesArr.map(category => {
                        if (category.name === "Rentals") {
                            return {
                                _id: category._id,
                                name: `${category.name} - የኪራይ ማስታወቂያዎች`
                            };
                        }

                        if (category.name === "Jobs") {
                            return {
                                _id: category._id,
                                name: `${category.name} - የስራ ማስታወቂያዎች`
                            };
                        }

                        if (category.name === "Babysitters & Nannies") {
                            return {
                                _id: category._id,
                                name: `${category.name} - የሞግዚት ማስታወቂያዎች`
                            };
                        }
                        if (category.name === "Events") {
                            return {
                                _id: category._id,
                                name: `${category.name} - የተለያዩ ዝግጅቶች`
                            };
                        }
                        if (category.name === "Buy & Sell") {
                            return {
                                _id: category._id,
                                name: `${category.name} - ግዢና ሽያጮች`
                            };
                        }
                        if (category.name === "Local Biz & Services") {
                            return {
                                _id: category._id,
                                name: `${category.name} - ንግድና አገልግሎቶች`
                            };
                        }

                        else {
                            return category;
                        }
                    });
                    updateAdsCategories(transformedCategories);
                }
            })
            .catch((err) => standardFetchHandlers.error(err));
    };

    const toggleModalVisibilty = (source, value) => {



        // if(value) document.body.classList.add("body-fixed");
        // else  document.body.classList.remove("body-fixed");
        // alert(`Yes${source}:${value}`);

        if (adsIds) {
            toggleModalForPostAdscategories(false);
        }

        switch (source) {
            case "roomRents":
                updateVisibilityForRoomRents(value)
                setReplacerental(value);
                break;
            case "jobs":
                updateVisibilityForJobs(value)
                setReplaceJobs(value)
                break;
            case "events":
                updateVisibilityForEvents(value)
                setReplaceEvents(value);
                break;

            case "babySitterAndNanny":
                updateVisibilityForBabySitterAndNanny(value)
                setReplaceBaby(value)
                break;

            case "buyAndSell":
                updateVisibilityForBuyAndSell(value)
                setReplaceBuySell(value)
                break;

            case "localBizServices":
                updateVisibilityForLocalBizAndService(value)
                setReplaceLocalBiz(value)
                break;

            default:
                break;
        }

    }

    useEffect(() => {
        if (checkJobEdit) {
            setReplaceJobs(prev => true);
        }

        if (checkRentalEdit) {
            // debugger
            setReplacerental(prev => true);
        }
        if (checkBabyEdit) {
            setReplaceBaby(prev => true);
        }

        if (checkEventEdit) {
            setReplaceEvents(prev => true);
        }

        if (checkLocalBizEdit) {
            setReplaceLocalBiz(prev => true)
        }

        if (checkBuySellEdit) {
            setReplaceBuySell(prev => true)
        }


    }, [checkJobEdit, checkRentalEdit, checkBabyEdit, checkEventEdit, checkLocalBizEdit, checkBuySellEdit]);
    //   const categoryTranslations = {
    //     "Babysitters & Nannies": "Babysitters & Nannies - ህጻን እና ናኒስ",
    //     "Buy & Sell": "Buy & Sell - አስተዳደር እና ሽመኝ",
    //     "Local Biz & Services": "Local Biz & Services - አካባቢ እና አገልግሎት እና አገልግሎቶች",
    //     "Events": "Events - ዕድሜዎች",
    //     "Jobs": "Jobs - ስራዎች",
    //     "Rentals": "Rentals - የኪራይ ማስታወቂያዎች"
    // };

    const onChangeHandler = (e) => {
        const adsId = e?.target?.value,
            optionText = e.target.selectedOptions[0].text;



        updatedSelectedAdsCategories({
            adsCategoriesId: adsId,
            optionText: optionText,
        })
    }

    // const onChangeHandler = (e) => {
    //     const adsId = e?.target?.value,
    //         optionText = e.target.selectedOptions[0].text;

    //     const translatedOptionText = categoryTranslations[optionText] || optionText;

    //     updatedSelectedAdsCategories({
    //         adsCategoriesId: adsId,
    //         optionText: translatedOptionText,
    //     });
    // }

    const handleSubmitCategories = (e) => {
        e.preventDefault();
        toast.dismiss();

        const selectedAdsCategoriesOtionId = selectedAdsCategories?.adsCategoriesId,
            selectedAdsCategoriesOtionText = selectedAdsCategories?.optionText;

        if (!(selectedAdsCategoriesOtionId || selectedAdsCategoriesOtionText)) {
            return toast.error("Please select category")
        }

        localStorage.setItem('adsCategories', JSON.stringify(selectedAdsCategoriesOtionText));

        if (selectedAdsCategoriesOtionText === "Jobs" && !selectedJobType) return toast.error("Please select job type")

        // switch (selectedAdsCategoriesOtionText) {
        switch (selectedAdsCategoriesOtionText.split(" - ")[0]) {
            case "Rentals":
                toggleModalVisibilty("roomRents", true);
                break;

            case "Jobs":
                toggleModalVisibilty("jobs", true);
                break;

            case "Babysitters & Nannies":
                toggleModalVisibilty("babySitterAndNanny", true);
                break;

            case "Buy & Sell":
                toggleModalVisibilty("buyAndSell", true);
                break;

            case "Local Biz & Services":
                toggleModalVisibilty("localBizServices", true);
                break;
            case "Events":
                toggleModalVisibilty("events", true);
                break;
            case "addJobsVisibilityModal":
                toggleModalForPostAdscategories(false);
                break;
            default:
                break;
        }

    }

    const handleCancelBtnClick = () => {
        toggleModalForPostAdscategories(false)
    }

    const onChangeHandlerFor = (e) => {
        updateSelectedJobType(e.target.value)

    }

    useEffect(() => {
        fetchingPostACategories();
    }, [])
    // alert(`Called ${isModalOpenForEvents}:${replaceEvents}:${adsIds}`);

    return (
        <>

            <CommonModalWrapper isOpen={isModalOpenForRoomRents || Replacerental && adsIds} className={style.room_rents_modal_wrapper} >
                {/* <CloseIcon onClick={() => toggleModalVisibilty("roomRents", false)} /> */}
                {/* <CloseIcon onClick={() => handleShowExitConfirm("roomRents")} /> */}
                <CloseIcon onClick={() => {
                    if (adsIds) {
                        toggleModalVisibilty("roomRents", false);
                        toggleModalForPostAdscategories && toggleModalForPostAdscategories(false);
                    } else {
                        handleShowExitConfirm("roomRents", currentRoomRentsStep);
                    }
                }} />
                <RoomRents
                    toggleModalVisibilty={toggleModalVisibilty}
                    adsCategoriesId={selectedAdsCategories?.adsCategoriesId}
                    adsIds={adsIds}
                    setadsIds={setadsIds}
                    setReplacerental={setReplacerental}
                    toggleModalForPostAdscategories={toggleModalForPostAdscategories}
                    post_type={adsCategories._id}
                    onRoomRentsIdChange={setCurrentRoomRentsId}
                    onStepChange={setCurrentRoomRentsStep}
                />
            </CommonModalWrapper>

            <CommonModalWrapper isOpen={isModalOpenForJobs || replaceJobs && adsIds} className={style.room_rents_modal_wrapper} >
                {/* <CloseIcon onClick={() => toggleModalVisibilty("jobs", false)} /> */}
                {/* <CloseIcon onClick={() => handleShowExitConfirm("jobs")} /> */}
                <CloseIcon onClick={() => {
                    if (adsIds) {
                        toggleModalVisibilty("jobs", false);
                        toggleModalForPostAdscategories && toggleModalForPostAdscategories(false);
                    } else {
                        handleShowExitConfirm("jobs",currentJobStep)
                    }
                }} />
                <Jobs toggleModalVisibilty={toggleModalVisibilty} adsCategoriesId={selectedAdsCategories?.adsCategoriesId} selectedJobType={selectedJobType} adsIds={adsIds} setadsIds={setadsIds} onJobIdChange={setCurrentJobId} onStepChange={setCurrentJobStep} />
            </CommonModalWrapper>

            <CommonModalWrapper isOpen={isModalOpenForEvents || replaceEvents && adsIds} className={style.room_rents_modal_wrapper} >
                {/* <CloseIcon onClick={() => toggleModalVisibilty("events", false)} /> */}
                {/* <CloseIcon onClick={() => handleShowExitConfirm("events")} /> */}
                <CloseIcon onClick={() => {
                    if (adsIds) {
                        toggleModalVisibilty("events", false);
                        toggleModalForPostAdscategories && toggleModalForPostAdscategories(false);
                    } else {
                        handleShowExitConfirm("events",currentEventStep);
                    }
                }} />
                <Events toggleModalVisibilty={toggleModalVisibilty} adsCategoriesId={selectedAdsCategories?.adsCategoriesId} adsIds={adsIds} setadsIds={setadsIds} onEventIdChange={setCurrentEventId} onStepChange={setCurrentEventStep}/>
            </CommonModalWrapper>


            <CommonModalWrapper isOpen={isModalOpenForBabySitterAndNanny || replaceBaby && adsIds} className={style.room_rents_modal_wrapper} >
                {/* <CloseIcon onClick={() => toggleModalVisibilty("babySitterAndNanny", false)} /> */}
                {/* <CloseIcon onClick={() => handleShowExitConfirm('babySitterAndNanny')} /> */}
                <CloseIcon onClick={() => {
                    if (adsIds) {
                        toggleModalVisibilty("babySitterAndNanny", false);
                        toggleModalForPostAdscategories && toggleModalForPostAdscategories(false);
                    } else {
                        handleShowExitConfirm("babySitterAndNanny",currentBabySitterStep);
                    }
                }} />
                <BabySitterAndNanny toggleModalVisibilty={toggleModalVisibilty} adsCategoriesId={selectedAdsCategories?.adsCategoriesId} adsIds={adsIds} setadsIds={setadsIds} onBabySitterChange={setCurrentBabySitterId} onStepChange={setCurrentBabySitterStep} />
            </CommonModalWrapper>

            <CommonModalWrapper isOpen={isModalOpenForBuyAndSell || replaceBuySell && adsIds} className={style.room_rents_modal_wrapper} >
                {/* <CloseIcon onClick={() => toggleModalVisibilty("buyAndSell", false)} /> */}
                {/* <CloseIcon onClick={() => handleShowExitConfirm('buyAndSell')} /> */}
                <CloseIcon onClick={() => {
                    if (adsIds) {
                        toggleModalVisibilty("buyAndSell", false);
                        toggleModalForPostAdscategories && toggleModalForPostAdscategories(false);
                    } else {
                        handleShowExitConfirm("buyAndSell",currentBuySellStep);
                    }
                }} />

                <BuyAndSell toggleModalVisibilty={toggleModalVisibilty} adsCategoriesId={selectedAdsCategories?.adsCategoriesId} adsIds={adsIds} setadsIds={setadsIds} onBuySellChange={setCurrentBuySellId} onStepChange={setCurrentBuySellStep}/>
            </CommonModalWrapper>

            <CommonModalWrapper isOpen={isModalOpenForLocalBizAndService || replaceLocalBiz && adsIds} className={style.room_rents_modal_wrapper} >
                {/* <CloseIcon onClick={() => toggleModalVisibilty("localBizServices", false)} /> */}
                {/* <CloseIcon onClick={() => handleShowExitConfirm('localBizServices')} /> */}
                <CloseIcon onClick={() => {
                    if (adsIds) {
                        toggleModalVisibilty("localBizServices", false);
                        toggleModalForPostAdscategories && toggleModalForPostAdscategories(false)
                    } else {
                        handleShowExitConfirm("localBizServices",currentLocalBizStep);
                    }
                }} />
                {/* <Modal show={isModalOpenForLocalBizAndService} onHide={()=>updateVisibilityForLocalBizAndService(false)}>
                    <Modal.Header closeButton >Hello New Modal</Modal.Header>
                </Modal> */}
                <LocalBizServices toggleModalVisibilty={toggleModalVisibilty} adsCategoriesId={selectedAdsCategories?.adsCategoriesId} adsIds={adsIds} onLocalBizChange={setCurrentLocalBizId} onStepChange={setCurrentLocalBizStep}/>
            </CommonModalWrapper>

            {<main className={style.main_wrapper}>
                <PostAdsHeading headingText='Post your Ad' subHeadingText='' />
                <form id={style.categories_form} onSubmit={handleSubmitCategories}>
                    <Inputs
                        required={true}
                        label='Categories'
                        type='select'
                        placeholder="Select ad category"
                        className={style.select_input}
                        name='ads-category'
                        selectInputOptions={adsCategories}
                        onChangeHandler={onChangeHandler}
                    />

                    {
                        selectedAdsCategories && selectedAdsCategories.optionText.split(" - ")[0] === "Jobs" &&
                        <Inputs
                            type="radio"
                            required={true}
                            onChangeHandler={onChangeHandlerFor}
                            name='jobType'
                            value={selectedJobType}
                            label='Select Type of Jobs Ad'
                            className={style.job_type_input}
                            radioBtnOtions={contactModeRadioBtn}
                        />
                    }
                    <FormButton backBtnClickHandler={handleCancelBtnClick} cancelButtonText='Cancel' submitBtnText='Next' />
                </form>
            </main>}

            {/* Main Exit Confirmation Modal */}
            <Modal show={showExitConfirmModal} onHide={handleHideExitConfirm} centered>
                <Modal.Header closeButton>

                </Modal.Header>
                <Modal.Body>Save as draft or delete your ad?</Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        onClick={handleShowSaveDraft}
                        style={{
                            backgroundColor: '#FFF0E5',
                            color: '#FD7E14',
                            borderColor: '#FD7E14'
                        }}
                    >
                        Save as Draft
                    </Button>
                    <Button
                        variant="danger"
                        onClick={handleShowDelete}
                        style={{
                            backgroundColor: '#FD7E14',
                            borderColor: '#FD7E14',
                            color: 'white'
                        }}
                    >
                        Delete your ad
                    </Button>
                    <Button
                        variant="light"
                        onClick={handleCancel}
                        style={{
                            backgroundColor: '#f8f9fa',
                            color: '#6c757d',
                            borderColor: '#dee2e6'
                        }}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Save Draft Confirmation Modal */}
            <Modal show={showSaveDraftModal} onHide={handleHideSaveDraft} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Save as Draft</Modal.Title>
                </Modal.Header>
                <Modal.Body>Do you want to save this ad as a draft?</Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="light"
                        onClick={handleHideSaveDraft}
                        style={{
                            backgroundColor: '#FFF0E5',
                            color: '#FD7E14',
                            borderColor: '#FD7E14'
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleSaveDraft}
                        style={{
                            backgroundColor: '#FD7E14',
                            borderColor: '#FD7E14',
                            color: 'white'
                        }}
                    >
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={handleHideDelete} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this draft post permanently?</Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="light"
                        onClick={handleHideDelete}
                        style={{
                            backgroundColor: '#FFF0E5',
                            color: '#FD7E14',
                            borderColor: '#FD7E14'
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={handleDeleteAd}
                        style={{
                            backgroundColor: '#FD7E14',
                            borderColor: '#FD7E14',
                            color: 'white'
                        }}
                    >
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}


